import { useQuery } from '@tanstack/react-query'

import { api } from '../../services/api'
import type { WeeklySpend } from '../../services/api'

/**
 * Weekly spend vs the user's role cap (APR-012).
 *
 * Returns `has_cap: false` when the role has no weekly cap, in which case
 * no tracker should be rendered (APR-012 AC3). Spend is week-to-date and
 * excludes any pending/unplaced order.
 */
export function useWeeklySpend() {
  return useQuery<WeeklySpend>({
    queryKey: ['weekly-spend'],
    queryFn: () => api.getWeeklySpend(),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
